<template>
  <section ref="scrollContainer" :class="['section', 'child-view', 'section--expertise']">
    <div class="wrapper">
      <div class="content">
        <div class="title-area">
          <h1>Our Expertise</h1>
          <p class="description">Mobidev is dedicated to continuously meeting client needs by combining established and cutting-edge tools to craft an optimal process and ensure the highest quality of solutions.</p>
        </div>
        <div class="info-area">
          <h2>Main Domains</h2>
          <p class="description">We provide our clients with consultancy services across a diverse range of expertise. Our track record includes the successful creation of design solutions for various industries, including healthcare, insurance, fintech, and numerous other project types.</p>
          <div class="cloud-holder">
            <div ref="tagCloud"></div>
          </div>
        </div>
        <div class="info-area">
          <h2>Design and Immersive Technologies</h2>
          <p class="description">In today’s dynamic landscape, digital design encounters a never-ending evolution of modern challenges. We stand ready to provide our expertise, applied to the foremost edge of user interactions.</p>
          <div class="expertise-container">
            <ul class="parts-number">
              <li class="number-1">
                <span class="number">/1</span>
                <span class="text">UX Design</span>
              </li>
              <li class="number-2">
                <span class="number">/2</span>
                <span class="text">UI Design</span>
              </li>
              <li class="number-3">
                <span class="number">/3</span>
                <span class="text"></span>
                <span class="desktop">AI & AR, VR, 3D, Unity</span>
                <span class="mobile">Interact</span>
              </li>
              <li class="number-4">
                <span class="number">/4</span>
                <span class="text">Graphic Design</span>
              </li>
            </ul>
            <ul class="circle-info">
              <li class="circle-button size-1 interact">
                <div class="text-holder">
                  <router-link :to="`/expertise/interact`">
                    <span class="text">Interact</span>
                  </router-link>
                </div>
              </li>
              <li class="circle-button size-3 ux">
                <div class="text-holder">
                  <router-link :to="`/expertise/ux`">
                    <span class="text">UX</span>
                  </router-link>
                </div>
              </li>
              <li class="circle-button size-1 design">
                <div class="text-holder">
                  <router-link :to="`/expertise/design-review`">
                    <span class="text">Design Review</span>
                  </router-link>
                </div>
              </li>
              <li class="circle-button size-3 ui">
                <div class="text-holder">
                  <router-link :to="`/expertise/ui`">
                    <span class="text">UI</span>
                  </router-link>
                </div>
              </li>
              <li class="circle-button size-3 graphic-design">
                <div class="text-holder">
                  <router-link :to="`/expertise/graphic-design`">
                    <span class="text">Graphic Design</span>
                  </router-link>
                </div>
              </li>
              <li class="circle-button size-1 interact">
                <div class="text-holder">
                  <router-link :to="`/expertise/ai`">
                    <span class="text">AI</span>
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="info-area">
          <h2>Technical Spectrum</h2>
          <p class="description">In today’s rapidly evolving technological landscape, we apply our competence to a wide range of devices and digital platforms.</p>
          <ul class="tech-list">
            <li class="web">
              <ul class="tech-sublist">
                <li class="desktop">Landing page</li>
                <li class="mobile">Landing &amp; Corporate page</li>
                <li class="desktop">Corporate page</li>
                <li>E-Commerce</li>
                <li class="desktop">CRM</li>
                <li class="desktop">ERP</li>
                <li class="mobile">ERP &amp; CRM systems</li>
              </ul>
            </li>
            <li class="mobile-app">
              <ul class="tech-sublist">
                <li>iOS</li>
                <li>Android</li>
                <li>Cross-platform</li>
              </ul>
            </li>
            <li class="desktop-app">
              <ul class="tech-sublist">
                <li>MacOS</li>
                <li>Windows</li>
                <li>Linux</li>
              </ul>
            </li>
            <li class="ai">
              <ul class="tech-sublist">
                <li>Conversational UI</li>
                <li>Visual Design</li>
                <li>AI Design Generation (Stitch, Lovable, Google AI studio, Antigravity, Claude Design)</li>
                <li>AI creation of Design Systems</li>
              </ul>
            </li>
            <li class="iot">
              <ul class="tech-sublist">
                <li class="desktop">Smart Home</li>
                <li class="mobile">
                  <span class="word">Smart Home</span>
                  <span class="word">Automotive</span>
                </li>
                <li>Power engineering</li>
                <li class="desktop">Automotive</li>
                <li>Health and beauty devices</li>
                <li>Consumer electronics</li>
              </ul>
            </li>
            <li class="pos">
              <ul class="tech-sublist">
                <li>POS Terminals</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <Footer/>
    </div>
  </section>
</template>

<script>
import Footer from '@/components/UI/Footer';
import { mapMutations } from 'vuex';
import * as TagCloud from 'TagCloud';

let savedExpertiseScroll = 0;

export default {
  data() {
    return {
      tagsForCloud: [
        '<span class="size-2">blockchain<span>', '<span class="size-3">Industrial<span>', '<span class="size-6">Insurance<span>', '<span class="size-6">Healthcare<span>', '<span class="size-3">Telecom<span>', '<span class="size-6">ML<span>', 'Wellness & Fitness', '<span class="size-3">Advertising<span>', 'E-Commerce', '<span class="size-6">HoReCa<span>', '<span class="size-6">AI<span>', '<span class="size-3">Entertainment<span>', 'CRM', '<span class="size-6">Data Science<span>', '<span class="size-3">Real Estate<span>', '<span class="size-2">cryptocurrency<span>', '<span class="size-6">IoT<span>', 'Education', '<span class="size-6">Fintech<span>', '<span class="size-3">Social Networking<span>', '<span class="size-6">AR&VR<span>', 'POS', '<span class="size-3">Marketing<span>', '<span class="size-2">Investment<span>', 'ERP', 'HRM', '<span class="size-3">Computer Vision<span>', 'Big data', '<span class="size-2">Beauty<span>', 'Logistics&Transportation',
      ],
    };
  },
  mounted() {
    this.buildTagCloud();
    if (savedExpertiseScroll > 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.scrollTop = savedExpertiseScroll;
          }
          window.scrollTo(0, savedExpertiseScroll);
        }, 80);
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!from.path.startsWith('/expertise/')) {
      savedExpertiseScroll = 0;
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    const container = this.$refs.scrollContainer;
    if (container) {
      savedExpertiseScroll = container.scrollTop || window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    next();
  },
  methods: {
    ...mapMutations(['showModal']),

    buildTagCloud() {
      let radius = (window.innerWidth - 160) / 2;
      if (window.innerWidth > 960) {
        radius = 350;
      }
      if (window.innerWidth < 500) {
        radius = 140;
      }
      TagCloud(this.$refs.tagCloud, this.tagsForCloud, { radius: radius, maxSpeed: 'slow', useHTML: true });
    },
  },
  components: {
    Footer,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Expertise.vue